/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ApplicationThirdStageData } from './ApplicationThirdStageData'
import {
  ApplicationThirdStageDataFromJSON,
  ApplicationThirdStageDataFromJSONTyped,
  ApplicationThirdStageDataToJSON,
} from './ApplicationThirdStageData'

/**
 *
 * @export
 * @interface GetDataThirdStage200Response
 */
export interface GetDataThirdStage200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetDataThirdStage200Response
   */
  status: boolean
  /**
   *
   * @type {ApplicationThirdStageData}
   * @memberof GetDataThirdStage200Response
   */
  data: ApplicationThirdStageData
}

/**
 * Check if a given object implements the GetDataThirdStage200Response interface.
 */
export function instanceOfGetDataThirdStage200Response(
  value: object
): value is GetDataThirdStage200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetDataThirdStage200ResponseFromJSON(
  json: any
): GetDataThirdStage200Response {
  return GetDataThirdStage200ResponseFromJSONTyped(json, false)
}

export function GetDataThirdStage200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDataThirdStage200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: ApplicationThirdStageDataFromJSON(json['data']),
  }
}

export function GetDataThirdStage200ResponseToJSON(
  value?: GetDataThirdStage200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: ApplicationThirdStageDataToJSON(value['data']),
  }
}
